import React from 'react'
import Container from '@material-ui/core/Container'
import styleClasses from '../components/common/common.module.scss'
import MonthlyReportsList from '../components/monthlyReports/MonthlyReportsList'

export default function MonthlyReportsPage() {
  return (
    <main className={styleClasses.content}>
      <Container maxWidth="lg" className={styleClasses.container}>
        <MonthlyReportsList />
      </Container>
    </main>
  )
}
